import { Badge, Person } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

import type { Appointment } from '../../types.ts'

interface Props {
  appointment: Appointment
}

export const SectionScout = ({ appointment }: Props) => {
  return (
    <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 45%' } }}>
      {appointment.scoutUUID ? (
        <Stack spacing={2}>
          <Box display="flex" alignItems="center" gap={1}>
            <Person color="action" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Scout Name
              </Typography>
              {appointment.scoutName ? (
                <Link
                  to={`/scouts/show/${appointment.scoutUUID}`}
                  style={{ textDecoration: 'none' }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'primary.main',
                      '&:hover': {
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    {appointment.scoutName}
                  </Typography>
                </Link>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  N/A
                </Typography>
              )}
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Badge color="action" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Scout ID
              </Typography>
              <Typography variant="body2">{appointment.scoutUUID}</Typography>
            </Box>
          </Box>
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No scout assigned
        </Typography>
      )}
    </Box>
  )
}

export default SectionScout
